"use client";

import React from "react";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Link } from "@/components/common/Link";
import { ArrowRight, ChevronRight, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function PerformanceSegmentsConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[480px] animate-pulse rounded-lg border border-border bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-muted-foreground">
          Impossibile caricare le categorie di prodotto.
        </p>
        <Button variant="outline" onClick={refetch} className="rounded-lg border-primary text-primary hover:bg-primary/10">
          Riprova Connessione
        </Button>
      </div>;
  }
  if (terms.length === 0) {
    return <p className="text-center text-muted-foreground">
        Nessuna soluzione disponibile al momento.
      </p>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {terms.map((term, i) => <Link key={term.id} to="/ProductsPage" data-index={i} className="group relative flex h-[480px] flex-col overflow-hidden rounded-lg border border-border bg-card shadow-md transition-all duration-500 hover:shadow-xl">
          {}
          {term.image_url && <img src={term.image_url} alt={term.name} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110" loading="lazy" />}

          {}
          <div className="absolute inset-0 bg-white/95 transition-colors duration-500 group-hover:bg-gradient-to-br group-hover:from-white/80 group-hover:to-primary/5" />

          {}
          <div className="relative z-10 flex h-full flex-col items-center justify-center p-8 text-center">
            {}
            <div className="mb-8 h-1 w-12 bg-ring transition-all duration-300 group-hover:w-24" />

            <h3 className="font-default text-3xl font-bold uppercase tracking-tight text-foreground">
              {term.name}
            </h3>

            {term.description && <p className="mt-4 line-clamp-2 max-w-[80%] text-sm text-muted-foreground opacity-100 transition-opacity duration-300 group-hover:opacity-0">
                {term.description}
              </p>}

            {}
            <div className="absolute bottom-0 left-0 w-full translate-y-full border-t border-border bg-white/95 p-6 backdrop-blur-md transition-transform duration-500 ease-in-out group-hover:translate-y-0">
              <div className="mb-4 flex items-center gap-2 border-b border-border/50 pb-2 text-ring">
                <Settings2 className="size-5" />
                <span className="font-mono text-xs font-semibold uppercase tracking-wider">
                  Specifiche Tecniche
                </span>
              </div>
              <ul className="space-y-3 text-left text-sm text-muted-foreground">
                <li className="flex items-start gap-3">
                  <ChevronRight className="mt-0.5 size-4 shrink-0 text-ring" />
                  <span>Ottimizzazione idrica avanzata</span>
                </li>
                <li className="flex items-start gap-3">
                  <ChevronRight className="mt-0.5 size-4 shrink-0 text-ring" />
                  <span>Sostenibilità certificata EU</span>
                </li>
                <li className="flex items-start gap-3">
                  <ChevronRight className="mt-0.5 size-4 shrink-0 text-ring" />
                  <span>Incremento resa agricola</span>
                </li>
              </ul>
              <div className="mt-6 flex items-center justify-between text-sm font-bold text-primary">
                <span>Scopri di più</span>
                <ArrowRight className="size-4 text-ring transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </div>
        </Link>)}
    </div>;
}
export default function PerformanceSegments() {
  return <section data-section-id="224637" id="soluzioni-per-la-terra" className="relative overflow-hidden bg-background py-24 text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-4xl font-bold uppercase tracking-tight text-foreground md:text-5xl">
            Soluzioni per la <span className="text-ring">Terra</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground font-default">Tecnologie d'avanguardia per la gestione idrica e la rigenerazione del suolo, progettate per le esigenze dei giardini e orticolture private e&nbsp; per l'eccellenza dell'agricoltura italiana.</p>
        </div>

        <EcommerceTermsProvider className="performance-segments-wrapper" wp_term_query={wp_term_query}>
          <PerformanceSegmentsConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}